import {UserCollectionDtoInterface} from './dto/user-collection-dto';
import {UserCollectionsService} from './user-collections.service';
import {AuthService} from '../../auth.service';
import {FilterUserCollectionDto} from './dto/filter-user-collection-dto';
import {BaseTableDataSource} from '../base-table-data-source';
import {BaseUserTableService} from '../base-user-table.service';

export class UserCollectionsDatasource extends BaseTableDataSource<UserCollectionDtoInterface, FilterUserCollectionDto> {

  constructor(public userService: UserCollectionsService, protected authService: AuthService) {
    super(authService);
  }

  protected getInitFilter(): FilterUserCollectionDto {
    return {};
  }

  protected getUserService(): BaseUserTableService<UserCollectionDtoInterface, FilterUserCollectionDto> {
    return this.userService;
  }

}
